export function judgmentTerminal() {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    // store.dispatch('app/isMobile', !!flag)
    return !!flag
    //   const meta = document.getElementsByTagName('meta')
    //   if (store.getters.isMobile) {
    //     // meta[2].content = 'width=375,initial-scale=1.0,maximum-scale=1.0,user-scalable=0,viewport-fit=cover'
    //     meta[2].content = 'width=375,user-scalable=0'
    //   } else {
    //     meta[2].content = 'width=device-width,initial-scale=1.0,user-scalable=no,minimum-scale=1,maximum-scale=1,viewport-fit=cover'
    //   }
    //   console.log(meta[2].content)
}